/*
  Options Theme
  Luxury Sticky Header + Mobile Menu
*/

document.addEventListener("DOMContentLoaded", () => {


  const header = document.querySelector(
    ".options-header[data-sticky-header]"
  );


  const menuButton = document.querySelector(
    ".options-header__menu-button"
  );


  const mobileMenu = document.querySelector(
    ".options-header__mobile-menu"
  );



  /*
    Sticky shadow on scroll
  */

  if(header){

    window.addEventListener("scroll", () => {


      if(window.scrollY > 20){

        header.classList.add(
          "options-header--scrolled"
        );


      } else {


        header.classList.remove(
          "options-header--scrolled"
        );


      }


    });


  }




  /*
    Mobile menu
  */

  if(menuButton && mobileMenu){


    menuButton.addEventListener(
      "click",
      () => {


        mobileMenu.classList.toggle(
          "active"
        );


        const expanded =
        mobileMenu.classList.contains(
          "active"
        );


        menuButton.setAttribute(
          "aria-expanded",
          expanded
        );


      }
    );


  }


});